<template>
  <div class="as-map-panels">
          <div class="as-panel as-panel--vertical as-panel--top as-panel--right">
            <div class="as-panel__element  as-p--8">
            <div class="as-box">
              <h2 class="as-subheader">Points of Interest</h2>
              <as-dropdown
                default-text='Scotiabank Arena'
                can-clear="false">
              </as-dropdown>
            </div>
            <!-- <div class="as-box">
              <h2 class="as-subheader">Date Picker</h2>
              <as-dropdown
                id = "datePicker"
                default-text= 'Sunday : 5/31/2019'
                can-clear="false">
              </as-dropdown>
            </div> -->
            </div>
          </div>
          <!-- <div class="as-panel as-panel--vertical as-panel--bottom as-panel--right">
          <div class="as-box">
            <as-histogram-widget
                x-label="Time"
                y-label="Visitors"
                responsive
                show-clear          >
            </as-histogram-widget>
        </div>
        </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import carto from '@carto/carto-vl'
import { scotiaTS, zooTS, congTS, botaTS } from '../lib/data'
// import * as airship from '@carto/airship-bridge'
export default {
  name: 'MapUI',
  data () {
    return {
      legendLabel: `Qty of visitors per FSA`
    }
  },
  mounted () {
    const store = this.$store
    const dropdown = document.querySelector('as-dropdown')
    dropdown.options = [
      { text: 'Scotiabank Arena', value: 'Scotiabank Arena' },
      { text: 'The Toronto Congress Center', value: 'The Toronto Congress Center' },
      { text: 'High Park Zoo', value: 'High Park Zoo' },
      { text: 'Toronto Botanical Garden', value: 'Toronto Botanical Garden' }
    ]
    dropdown.addEventListener('optionChanged', (event) => {
      store.commit('setPlace', event.detail)
    })
    const timeData = this.timeData(scotiaTS)
    let timeSeriesWidget = document.querySelector('as-time-series-widget')
    timeSeriesWidget.data = timeData
    timeSeriesWidget.timeFormat = '%x'
    timeSeriesWidget.addEventListener('selectionChanged', (e) => {
      if (e.detail !== null) {
        console.log([e.detail[0], e.detail[1]])
        this.$store.commit('setDateRange', [e.detail[0], e.detail[1]])
      } else {
        this.$store.commit('setDateRange', null)
        setTimeout(() => {
          document.querySelector('.loaded').style.opacity = '0.8'
          document.querySelector('.loaded').style.zIndex = '1000'
        }, 0)
        setTimeout(() => {
          document.querySelector('.loaded').style.opacity = '0'
          document.querySelector('.loaded').style.zIndex = '-1'
        }, 2500)
      }
    })
    timeSeriesWidget.addEventListener('click', (e) => {
      console.log('coucou')
      return null
    })
  },
  methods: {
    filterLayer (dateRange) {
      document.querySelector('.loaded').style.opacity = '0.8'
      const layer = global.map.getLayer('telus')
      const poiLayer = global.map.getLayer('poi')
      let query = ``
      if (dateRange) {
        if (dateRange[0] === dateRange[1]) { dateRange[1] = dateRange[0] + 86400 }
        query = `
                SELECT t1.cartodb_id, t1.location_name, t1.cfsaidu, sum(t1.visitors) visitors, t1.the_geom, t1.the_geom_webmercator  
                FROM acc_daily_visitors_2 t1
                WHERE t1.location_name = '${this.place}'
                  AND (t1.datetime >= ${dateRange[0]} AND t1.datetime <= ${dateRange[1]})
                GROUP BY t1.cartodb_id, t1.location_name, t1.cfsaidu, t1.the_geom, t1.the_geom_webmercator
                `
      } else {
        query = `
                SELECT t1.cartodb_id, t1.location_name, t1.cfsaidu, sum(t1.visitors) visitors, t1.the_geom, t1.the_geom_webmercator  
                FROM acc_daily_visitors_2 t1
                WHERE t1.location_name = '${this.place}'
                  AND (t1.datetime >=  (SELECT min(datetime) FROM acc_daily_visitors_2) AND datetime < (SELECT max(datetime) FROM acc_daily_visitors_2))
                GROUP BY t1.cartodb_id, t1.location_name, t1.cfsaidu, t1.the_geom, t1.the_geom_webmercator
              `
      }
      const source = new carto.source.SQL(query, {
        apiKey: '97212563298641dbf0fd6a32d2cc9504e3fe468a',
        username: 'anagraph-clement'
      })
      var viz = new carto.Viz(`
        color: opacity(ramp(globalQuantiles($visitors,6),[#441853,#45367F,#37648E,#289E87,#66BE64,#F7E822]),0.86)
        @location_name: $location_name
        @cfsaidu: $cfsaidu
        @visitors: $visitors
        @viewportCount: viewportSum($visitors)
      `)
      layer.implementation.update(source, viz)
      setTimeout(() => {
        document.querySelector('.loaded').style.opacity = '0'
        document.querySelector('.loaded').style.zIndex = '-1'
      }, 2500)
      poiLayer.implementation.viz.filter.blendTo(`$name == '${this.place}'`, 500)
    },
    timeData (data) {
      var myArr = []
      data.map((x) => {
        myArr.push(
          {
            start: new Date(Date.parse(this.epochToDate(x.datetime - 1))),
            end: new Date(Date.parse(this.epochToDate(x.datetime))),
            value: x.visitors
          }
        )
      })
      return myArr
    },
    epochToDate (epoch) {
      let d = new Date(0) // The 0 there is the key, which sets the date to the epoch
      d.setUTCSeconds(epoch)
      return d
    }
  },
  computed: {
    ...mapState({
      featureNb: state => state.featureNb,
      date: state => state.date,
      place: state => state.place,
      dateRange: state => state.dateRange
    })
  },
  watch: {
    place: {
      handler: function (n, o) {
        let timeSeriesWidget = document.querySelector('as-time-series-widget')
        if (n === 'High Park Zoo') {
          console.log(n)
          timeSeriesWidget.data = this.timeData(zooTS)
        } else if (n === 'The Toronto Congress Center') {
          console.log(n)
          timeSeriesWidget.data = this.timeData(congTS)
        } else if (n === 'Toronto Botanical Garden') {
          console.log(n)
          timeSeriesWidget.data = this.timeData(botaTS)
        } else if (n === 'Scotiabank Arena') {
          console.log(n)
          timeSeriesWidget.data = this.timeData(scotiaTS)
        }
        if (!this.dateRange) {
          this.filterLayer(null)
        } else {
          this.filterLayer([this.dateRange[0], this.dateRange[1]])
        }
      },
      deep: true
    },
    dateRange: {
      handler: function (n, o) {
        if (!n) {
          this.filterLayer(null)
        } else {
          this.filterLayer([
            new Date(Date.parse(n[0])).getTime() / 1000,
            new Date(Date.parse(n[1])).getTime() / 1000
          ])
        }
      },
      deep: true
    }
  }
}
</script>

<style>
as-legend-color-continuous-polygon .as-legend-color-continuous-polygon--outer-wrapper.as-legend-color-continuous-polygon--vertical {
    justify-content: space-evenly;
}
.as-panel__element {
  background: rgba(255,255,255,0.7) !important;
}
as-legend-color-continuous-polygon .as-legend-color-continuous-polygon--label {
    font-size: medium;
}

as-dropdown .as-dropdown--open .as-dropdown__list {
    display: contents;
}
.as-color--type-01{
  color: #FEC503 !important;
}

.as-widget-selection__selection as-body {
  color: #FEC503 !important;
}
ul {
    list-style-type: none;
}
</style>
